@if (columnType === 'BOOLEAN' && data !== null) {
  <div class="boolean-container">
    <app-admin-boolean-value [value]="data"></app-admin-boolean-value>
  </div>
} @else if (columnType === 'DATE') {
  {{ data ? datePipe.transform(data, 'd MMM y HH:mm:ss') : '' }}
} @else if (columnType === 'DURATION') {
  {{ data ? (data | duration) : '' }}
} @else if (columnType === 'CALL') {
  @if (data !== null) {
    <a [routerLink]="['/app', 'admin', 'meetings', data.id]" queryParamsHandling="merge">
      @let isMarkedToBeDeleted = data.markedToBeDeletedAt !== null;
      <span [class.deleted]="isMarkedToBeDeleted">
        {{ data.name }}<span class="no-select"> ({{ data.id }})</span></span
      >
      @if (isMarkedToBeDeleted) {
        <br />
        ({{ 'COMMON.DELETED_AT' | translate }} {{ datePipe.transform(data.markedToBeDeletedAt, 'd MMM y HH:mm:ss') }})
      }
    </a>
  } @else {
    -
  }
} @else if (columnType === 'USER') {
  @if (data !== null) {
    <a [routerLink]="['/app', 'admin', 'users', data.id]" queryParamsHandling="merge">
      {{ data.email }}<span class="no-select"> ({{ data.id }})</span></a
    >
  } @else {
    -
  }
} @else if (columnType === 'USER_AVATAR_LIST') {
  @if (data !== null) {
    <div class="user-avatar-list">
      @if (currentUser$ | async; as user) {
        @for (item of data; track $index) {
          @if (user.role === 'SUPER') {
            <a [routerLink]="['/app', 'admin', 'users', item.id]" queryParamsHandling="merge">
              <app-avatar [input]="item.name" size="small" [matTooltip]="item.name"></app-avatar>
            </a>
          } @else {
            <app-avatar [input]="item.name" size="small" [matTooltip]="item.name"></app-avatar>
          }
        }
      }
    </div>
  } @else {
    -
  }
} @else if (columnType === 'ORGANIZATION') {
  @if (data !== null) {
    <a
      class="organization-badge"
      [style.background-color]="getOrganizationColor(data.id)"
      [routerLink]="['/app', 'admin', 'organizations', data.id]"
      queryParamsHandling="merge"
    >
      {{ data.name }}<span class="no-select"> ({{ data.id }})</span>
    </a>
  } @else {
    -
  }
} @else if (columnType === 'CALL_STATUS') {
  @if (data.status === 'CREATED') {
    @if (data.latestCallSessionStatus === 'QUEUED') {
      <mat-icon [matTooltip]="'CALLS.STATUSES.QUEUED' | translate">schedule</mat-icon>
    } @else if (data.latestCallSessionStatus === 'WAITING_TO_START') {
      <mat-icon style="color: blue" [matTooltip]="'CALLS.STATUSES.WAITING_TO_START' | translate">pending</mat-icon>
    } @else if (data.latestCallSessionStatus === 'CONNECTING') {
      <mat-icon style="color: blue" [matTooltip]="'CALLS.STATUSES.CONNECTING' | translate">call_made</mat-icon>
    } @else if (data.latestCallSessionStatus === 'WAITING_TO_BE_ADMITTED') {
      <mat-icon style="color: blue" [matTooltip]="'CALLS.STATUSES.WAITING_TO_BE_ADMITTED' | translate">hourglass_empty</mat-icon>
    } @else if (data.latestCallSessionStatus === 'CONNECTED') {
      <mat-icon style="color: blue" [matTooltip]="'CALLS.STATUSES.CONNECTED' | translate">call</mat-icon>
    } @else if (data.latestCallSessionStatus === 'PAUSED') {
      <mat-icon style="color: yellow" [matTooltip]="'CALLS.STATUSES.PAUSED' | translate">pause_circle</mat-icon>
    } @else if (data.latestCallSessionStatus === 'HANGING_UP') {
      <mat-icon style="color: red" [matTooltip]="'CALLS.STATUSES.HANGING_UP' | translate">call_end</mat-icon>
    } @else {
      <mat-icon [matTooltip]="'CALLS.STATUSES.CREATED' | translate">fiber_manual_record</mat-icon>
    }
  } @else if (data.status === 'TIMEOUT') {
    <mat-icon style="color: red" [matTooltip]="'CALLS.STATUSES.TIMEOUT' | translate">alarm</mat-icon>
  } @else if (data.status === 'ERRORED') {
    <mat-icon style="color: red" [matTooltip]="'CALLS.STATUSES.ERRORED' | translate">error</mat-icon>
  } @else if (data.status === 'COMPLETED') {
    @if (data.processingStatus === 'PROCESSING_MEDIA') {
      <mat-icon [matTooltip]="'CALLS.PROCESSING_STATUSES.PROCESSING_MEDIA' | translate">movie</mat-icon>
    } @else if (data.processingStatus === 'PROCESSING_TRANSCRIPT') {
      <mat-icon [matTooltip]="'CALLS.PROCESSING_STATUSES.PROCESSING_TRANSCRIPT' | translate">description</mat-icon>
    } @else if (data.processingStatus === 'PROCESSING_SPEAKERS') {
      <mat-icon [matTooltip]="'CALLS.PROCESSING_STATUSES.PROCESSING_SPEAKERS' | translate">record_voice_over</mat-icon>
    } @else if (data.processingStatus === 'GENERATING_MINUTES') {
      <mat-icon [matTooltip]="'CALLS.PROCESSING_STATUSES.GENERATING_MINUTES' | translate">summarize</mat-icon>
    } @else {
      <mat-icon style="color: green" [matTooltip]="'CALLS.STATUSES.COMPLETED' | translate">check_circle</mat-icon>
    }
  }
} @else if (columnType === 'COMPLETED_CALL_STATUS') {
  @if (data.processingStatus !== null) {
    <mat-chip class="status-chip chip-processing">
      {{ 'COMMON.PROCESSING' | translate }}
    </mat-chip>
  } @else if (data.status === 'ERRORED' || data.latestCallSessionStatus === 'ERRORED') {
    <mat-chip class="status-chip chip-errored">
      {{ 'CALLS.STATUSES.ERRORED' | translate }}
    </mat-chip>
  } @else {
    <mat-chip class="status-chip chip-completed">
      {{ 'COMMON.COMPLETED' | translate }}
    </mat-chip>
  }
} @else if (columnType === 'CALL_USERS') {
  @for (callUser of data; track callUser.userId) {
    <div>
      <a [routerLink]="['/app', 'admin', 'users', callUser.userId]" queryParamsHandling="merge">
        {{ callUser.user.email }}<span class="no-select"> ({{ callUser.userId }})</span></a
      >
    </div>
  }
} @else if (columnType === 'LIST') {
  <ul>
    @for (item of data; track $index) {
      <li>{{ item }}</li>
    }
  </ul>
} @else if (columnType === 'JSON') {
  @if (data !== null) {
    {{ data | json }}
  } @else {
    -
  }
} @else if (columnType === 'MEETING_PROVIDER') {
  @if (data === 'ZOOM') {
    <mat-icon [matTooltip]="'Zoom'" style="color: #2d8cff">videocam</mat-icon>
  } @else if (data === 'TEAMS') {
    <mat-icon [matTooltip]="'Microsoft Teams'" style="color: #5059c9">groups</mat-icon>
  } @else if (data === 'GMEET') {
    <mat-icon [matTooltip]="'Google Meet'" style="color: #00832d">duo</mat-icon>
  } @else {
    -
  }
} @else if (columnType === 'NUMBER_WITH_ONE_DECIMAL') {
  @if (isValidNumber(data)) {
    {{ data.toFixed(1) }}
  } @else if (typeof data === 'string') {
    {{ data }}
  } @else {
    -
  }
} @else if (columnType === 'UPLOADED_DOCUMENTS') {
  <div class="uploaded-documents">
    @for (document of data; track document.resourceType) {
      @if (document.resourceType === 'AGENDA') {
        <mat-icon [matTooltip]="document.fileName + ' (' + formatFileSize(document.size) + ')'" class="document-icon">event_note</mat-icon>
      } @else if (document.resourceType === 'CUSTOM_DOCUMENT') {
        <mat-icon [matTooltip]="document.fileName + ' (' + formatFileSize(document.size) + ')'" class="document-icon">library_books</mat-icon>
      }
    }
  </div>
} @else if (columnType === 'STARTS_IN') {
  @let timing = getTimingState(data);
  @if (timing !== null) {
    @if (timing.type === 'upcoming') {
      <span class="starts-in">{{ timing.text }}</span>
    } @else {
      <div class="ongoing-progress">
        <mat-progress-bar mode="determinate" [value]="timing.progress"></mat-progress-bar>
        <span class="ongoing-progress-label">{{ timing.progress }}%</span>
      </div>
    }
  } @else {
    -
  }
} @else if (columnType === 'CALL_TYPE') {
  {{ 'CALLS.ADMIN.TYPE.' + data | translate }}
} @else {
  {{ data }}
}
